/** Code → display label. Mirrors backend TGLN value_conversions_dialysis_providers.js */
export const DIALYSIS_PROVIDER_OATS_LABELS = {
  "1": "Unknown",
  "2": "Adam Linton Dialysis Unit",
  "3": "Alberta Hospital",
  "4": "Alexandra Marine and General Hospital - Goderich",
  "5": "Arbour Creek Long-Term Care Centre",
  "8": "Belleville Dialysis Clinic",
  "9": "Bethammi Nursing Home",
  "10": "Blanche River Health - Kirkland Lake Site",
  "11": "Bluewater Health - Charlotte Eleanor Englehart Hospital",
  "12": "Bluewater Health - Sarnia",
  "14": "Brampton Civic Hospital",
  "15": "Bridgepoint Health",
  "16": "British Columbia Hospital",
  "17": "Brockville Dialysis Clinic IHF",
  "18": "Burlington Dialysis Center",
  "19": "Carveth Care Centre",
  "20": "Case Manor",
  "21": "Scarborough Centenary Hospital",
  "22": "Centennial Place",
  "23": "Chatham - Kent Health Alliance",
  "24": "CHEO",
  "25": "The Ottawa Hospital - Civic Site",
  "26": "Collingwood General & Marine Hospital",
  "27": "St. Joseph's Health Centre Toronto - Community Renal Centre",
  "28": "Cornwall Eastern Ontario Dialysis Clinic IHF",
  "29": "Cornwall Community Hospital",
  "30": "Country Terrace",
  "31": "DMC - Ajax/Pickering",
  "32": "DMC - Markham",
  "33": "DMC - Peterborough",
  "34": "Englehart and District Hospital",
  "35": "Erie Shores Healthcare",
  "36": "Etobicoke General Hospital",
  "37": "Extendicare West End Villa",
  "38": "Forest Heights Long-Term Care Centre",
  "39": "Fort Frances Satellite",
  "40": "Grand River Hospital - Freeport Site",
  "41": "Gardenview Long Term Care Home",
  "42": "Georgian Bay General Hospital - Midland Site",
  "44": "Golden Plough Lodge",
  "45": "Grand River Hospital Corporation",
  "46": "Grey Bruce Health Services - Markdale Hospital",
  "47": "Grey Bruce Health Services - Meaford Hospital",
  "48": "Grey-Bruce Health Services - Owen Sound",
  "49": "Grove Park Home",
  "50": "Guelph General Hospital",
  "51": "Halton Healthcare Services",
  "52": "Halton Healthcare - Milton District Hospital",
  "54": "Hamilton Health Sciences - Juravinski Hospital",
  "55": "Hamilton Health Sciences - Mcmaster Children's Hospital",
  "56": "Hamilton Health Sciences - St. Peter's Hospital",
  "57": "Hamilton Health Sciences - Hamilton General Hospital",
  "58": "Hanover And District Hospital",
  "59": "Hawkesbury General Hospital",
  "60": "Headwaters Health Care Centre",
  "61": "Health Sciences North",
  "62": "Hillsdale Estates",
  "63": "Hopital Montfort",
  "64": "Hospital for Sick Children",
  "66": "Hotel-Dieu Grace Healthcare",
  "68": "Humber River Hospital",
  "71": "Huron Perth Healthcare Alliance - Stratford General Hospital",
  "72": "Idlewyld Manor",
  "73": "Joseph Brant Hospital",
  "75": "St. Michael's Hospital Kidney Care Centre",
  "76": "Kingston General Hospital",
  "77": "Kirkland And District Hospital - Kirkland Lake",
  "78": "Lake Of The Woods District Hospital",
  "79": "Lakeridge Health Corporation",
  "80": "Leamington Satellite",
  "81": "Leisureworld Caregiving Centre - Mississauga",
  "82": "Lion's Camp Dorset Corporation",
  "83": "London Health Sciences Centre",
  "84": "Mackenzie Health",
  "85": "Manitoba Hospital",
  "86": "Manitoba Transplant Program",
  "87": "Manitoulin Health Centre - Little Current",
  "88": "Mariann Nursing Home And Residence",
  "89": "Markham - Stouffville Hospital",
  "90": "Mics Group of Health Services - Bingham Memorial Hospital",
  "91": "Mon Sheong Richmond Hill Long-Term Care",
  "92": "Mon Sheong Scarborough Long-Term Care Centre",
  "93": "Moose Factory Satellite - Kingston Health Sciences Centre",
  "94": "Mount Sinai Hospital",
  "95": "Muskoka Algonquin Healthcare",
  "96": "Napanee Satellite Dialysis Unit",
  "97": "New Brunswick Health & Wellness",
  "98": "New Brunswick Hospital",
  "99": "New Liskeard - Temiskaming",
  "100": "Newfoundland Hospital",
  "101": "Niagara Health - Niagara Falls General Site",
  "103": "Niagara Health - Douglas Memorial Site",
  "104": "Niagara Health - Port Colborne Site",
  "105": "Niagara Health - St. Catharines Site",
  "106": "Norfolk General Hospital",
  "107": "North Bay Regional Health Centre",
  "108": "North Wellington Health Care - Palmerston Site",
  "109": "North York General Hospital",
  "110": "North York General Hospital - Branson Ambulatory Care Centre",
  "111": "Northumberland Hills Hospital",
  "112": "Northwest Territories Hospital",
  "113": "Not Listed",
  "114": "Nova Scotia Hospital",
  "115": "Nunavut Hospital",
  "116": "Oak Ridges Satellite",
  "117": "Oshweken - Six Nations Satellite",
  "119": "Orillia Soldiers' Memorial Hospital",
  "120": "Other Country Hospital",
  "121": "Ottawa - Heart Institute",
  "122": "Ottawa Carleton Dialysis Clinic IHF",
  "123": "Peel Memorial Centre",
  "124": "Pembroke General Hospital",
  "125": "Georgian Bay General Hospital - Penetanguishene Site",
  "126": "Perth And Smiths Falls",
  "127": "Peterborough Regional Health Centre",
  "128": "Peterborough Clinic",
  "129": "Picton Dialysis Unit",
  "131": "Prince Edward Island Hospital",
  "132": "Princess Margaret Hospital",
  "133": "Providence Healthcare",
  "134": "Quebec Hospital",
  "135": "Queensway Carleton Hospital",
  "136": "Quinte Healthcare - Bancroft",
  "137": "Quinte Healthcare - Picton",
  "138": "Rekai Centre - Sherbourne Place",
  "139": "Trillium Health Partners - Renal Care Centre",
  "140": "Renfrew Victoria Hospital",
  "141": "The Ottawa Hospital - Riverside Site",
  "142": "Rockcliffe Nursing Home",
  "143": "Ross Memorial Hospital - Lindsay",
  "144": "Royal Terrace",
  "145": "Royal Victoria Regional Health Centre",
  "146": "Royal Victoria Regional Health Centre-Wellington Satellite",
  "147": "Saskatchewan Hospital",
  "148": "Saskatchewan Transplant Program",
  "149": "Sault Area Hospital",
  "150": "Scarborough Health Network - Centenary",
  "151": "Scarborough Health Network - Birchmount",
  "152": "Scarborough General Hospital",
  "153": "Scarborough HD Satellite Unit",
  "154": "Sensenbrenner Hospital - Kapuskasing",
  "155": "Sheppard Centre",
  "156": "Simcoe Manor - Beeton",
  "157": "Simcoe Manor Home for the Aged",
  "158": "Sioux Lookout Satellite",
  "159": "Sisters of Charity of Ottawa",
  "160": "Southlake Hospital",
  "161": "St. Francis Memorial Hospital - Barry's Bay",
  "162": "St. Joseph's Care Group - Thunder Bay",
  "163": "St Joseph's Health Centre Guelph",
  "164": "St. Joseph's General Hospital - Elliott Lake",
  "165": "St. Joseph's Healthcare - Hamilton",
  "166": "St Joseph's Health Care London - St. Josep's Hospital",
  "168": "St. Joseph's Lifecare Centre",
  "169": "St. Joseph's Villa",
  "170": "St. Louis Residence",
  "171": "St. Mary's General Hospital",
  "172": "St. Michael's Hospital",
  "173": "St. Joseph's Health Centre Toronto",
  "174": "Stevenson Memorial Hospital - Alliston",
  "175": "Stirling Heights Long-Term Care Centre",
  "176": "Stoney Creek",
  "177": "Sun Parlor Home, County Of Essex",
  "178": "Sunnybrook Health Sciences Centre",
  "179": "Sunnybrook Satellite",
  "180": "Sussex Centre",
  "181": "Brantford General Hospital",
  "182": "The John M. Parrott Centre",
  "183": "The O'Neill Centre",
  "184": "The Ottawa Hospital - General Site",
  "185": "The Ottawa Hospital - Civic Campus",
  "186": "The Ottawa Hospital - Riverside Campus",
  "187": "Thunder Bay Regional Health Sciences Centre",
  "188": "Tillsonburg District Memorial Hospital",
  "189": "Timmins And District Hospital",
  "190": "Toronto East General Hospital",
  "191": "Toronto General - Eaton Ground",
  "192": "Toronto General Hospital",
  "193": "Toronto Rehab Institute - Bickle Centre",
  "194": "Toronto Rehab Institute",
  "195": "Toronto Western Hospital",
  "196": "Trillium Health Partners - Credit Valley Hospital",
  "197": "Trillium Manor",
  "198": "Trillium Health Partners - Mississauga Hospital",
  "199": "Trillium Health Partners - West Toronto Site",
  "200": "USA Hospital",
  "201": "Vaughan Satellite",
  "202": "Villa St. Gabriel Villa",
  "203": "Niagara Health - Welland Site",
  "204": "Weeneebayko Area Health Authority - Weeneebayko General Hospital",
  "206": "Wellington Terrace Long-Term Care Home",
  "207": "West Parry Sound Health Centre",
  "208": "Westmount Kidney Care Centre",
  "210": "Winchester Memorial Hospital",
  "211": "Windsor Regional Hospital - Bell Site",
  "212": "Windsor Regional Hospital - Ouellette Site",
  "213": "Woodstock General Hospital",
  "214": "Wyndham Manor",
  "215": "Yee Hong Centre - Geriatric Care - Satellite",
  "216": "Yee Hong Centre - Scarborough Finch - Satellite"
};
